var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_810_654)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_810_654",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 0H0V100H100V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_810_654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.6123 0.000194481C45.6529 0.0134847 42.9081 0.377635 39.5902 0.975696C29.7923 2.75658 28.0073 6.49644 28.0073 13.3887V23.9225H50.9237V29.2385H27.1367H16.0604C9.34844 29.2385 3.47423 32.54 1.61293 40.4529C-0.490279 49.5354 -0.58449 55.2235 1.61293 64.7075C3.28073 71.7806 6.95496 77.0833 13.6694 77.0833H22.9175V63.5167C22.9175 55.6329 29.7567 47.845 37.594 47.845H56.0187C62.4429 47.845 68.75 42.8956 68.75 36.2106V13.3887C68.75 6.90577 64.271 2.05752 58.01 0.970379C58.1652 0.954429 53.5387 -0.0157538 49.6123 0.000194481ZM36.9219 10.6324C39.0123 10.6324 40.7412 12.4318 40.7412 14.6247C40.7412 16.8389 39.0123 18.6065 36.9219 18.6065C34.7906 18.6065 33.1025 16.8415 33.1025 14.6247C33.1025 12.4398 34.7906 10.6324 36.9219 10.6324Z",
    fill: "#0277BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.38 99.9998C51.5794 99.9865 54.4905 99.6223 58.0092 99.0244C68.4007 97.2434 70.2936 93.5036 70.2936 86.6113V76.0775H45.9894V70.7615H71.2198H82.9669C90.0855 70.7615 96.3155 67.46 98.2894 59.5471C100.52 50.4646 100.62 44.7765 98.2894 35.2925C96.518 28.2194 92.6211 22.9167 85.5 22.9167H75.6919V36.4834C75.6919 44.3671 68.4384 52.155 60.1263 52.155H40.5857C33.7725 52.155 27.0834 57.1044 27.0834 63.7894V86.6113C27.0834 93.0942 31.8336 97.9425 38.474 99.0296C38.3092 99.0456 43.2161 100.016 47.38 99.9998ZM60.8419 89.3677C58.6248 89.3677 56.7913 87.5681 56.7913 85.3752C56.7913 83.1611 58.6248 81.3936 60.8419 81.3936C63.1023 81.3936 64.8927 83.1586 64.8927 85.3752C64.8927 87.5602 63.0996 89.3677 60.8419 89.3677Z",
    fill: "#FFC107"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_810_654"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.bc29b465e7b083d08c0e66fb5b0e347f.svg";
export { ForwardRef as ReactComponent };